export enum ProcessCartAction {
  UPDATE = "update",
  CREATE = "create",
}

export interface Collection {
  id: string;
  title: string;
}

export interface GetCollectionsResponse {
  collections: Collection[];
}

export interface CreateAndUpdateCollectionResponse {
  collectionId: string; // Id for URL?
  message: string;
}
